<div class="c-overlay"
     [@fade]="formAnimationState"
     (@fade.done)="formAnimationDone()">

  <section class="c-contract">

    <h2 class="c-contract__title">
      Atualização dos termos de uso da plataforma
    </h2>

    <!--suppress HtmlUnknownAnchorTarget -->
    <iframe class="c-contract__pdf"
            src="assets/pdf/termo-de-uso-redacao-N1000.pdf#toolbar=0&view=FitH"
            width="100%" height="500px"></iframe>

    <div class="c-contract__controls">
      <button matRipple
              class="c-contract__button c-button c-button--solid c-button--large t-primary"
              [disabled]="isLoading"
              (click)="accept($event)">
        Aceitar
      </button>

      <a href="#"
         matRipple
         class="c-contract__link"
         (click)="cancel($event)">
        Cancelar
      </a>
    </div>

  </section>
</div>
